/* eslint-disable import/prefer-default-export */
export const MemberDetails = {
  memberInformation: {
    title: 'ACDT',
    firstName: 'Elaine',
    middleName: '',
    lastName: 'Benes',
    preferredName: '',
    dateOfBirth: '2000-01-01',
    sex: 'Female',
    coveredOnMembership: 'Policy Holder',
    coveredOnMembershipAsCode: 'MEMBR',
    residentialAddress: {
      dpId: null,
      postcode: '3006',
      state: 'NSW',
      addressLine1: '20 Exhibition Street',
      addressLine2: '',
      addressLine3: '',
      suburb: 'Melbourne',
      stateLastModified: '',
    },
  },
  contactInformation: {
    mobilePhoneNumber: '0411 111 111',
    workPhoneNumber: '',
    homePhoneNumber: '',
    email: 'elaine.benes111@gmail.com',
    postalAddress: {
      dpId: null,
      postcode: '3006',
      state: 'VIC',
      addressLine1: 'PO Box 123',
      addressLine2: '',
      addressLine3: '',
      suburb: 'Melbourne',
    },
    preferredCommunicationMethod: 'EMAIL',
    suppressCommunicationFlag: true,
    paymentAdvice: true,
  },
  privacyAccess: {
    keepPrivate: true,
    policyPermission: 'Self Access',
  },
  veteranCard: {
    hasVeteranCard: true,
    veteranCardList: [
      {
        id: '123',
        cardType: 'Veteran White Card',
        startDate: '2021-11-30',
        endDate: '2024-01-01',
        acceptedConditions: [
          {
            id: '1',
            code: 'DVAC1',
            startDate: '2021-12-16',
            endDate: '2024-12-17',
          },
          {
            id: '7',
            code: 'DVAC7',
            startDate: '2021-12-16',
            endDate: '',
          },
        ],
      },
      {
        id: '',
        cardType: 'Veteran White Card',
        startDate: '2021-12-15',
        endDate: '2021-12-16',
        acceptedConditions: [
          {
            id: '1',
            code: 'DVAC1',
            startDate: '2021-12-16',
            endDate: '',
          },
        ],
      },
      {
        id: '',
        cardType: 'Veteran Gold Card',
        startDate: '2021-12-15',
        endDate: '2021-12-16',
        acceptedConditions: [],
      },
      {
        id: null,
        cardType: 'Veteran White Card',
        startDate: '2021-12-16',
        endDate: '2021-12-17',
        acceptedConditions: [
          {
            code: 'DVAC1',
            endDate: '',
            id: null,
            startDate: '2021-12-16',
          },
        ],
      },
      {
        id: null,
        cardType: 'Veteran Gold Card',
        startDate: '2021-12-16',
        endDate: '2022-01-01',
        acceptedConditions: [],
      },
    ],
  },
  eligibility: {
    declarationIsConfirmed: true,
    dischargeDate: '2021-01-01',
    eligibilitySubject: 'Self',
    eligibilityType: 'ExServing',
    enlistmentDate: '2020-01-01',
    sercatFileNames: '',
    sercatStatus: '',
    subjectDepartmentOrCompanyName: 'Navy',
    subjectEligibilityType: '',
    subjectName: '',
    subjectRank: '',
    subjectRelation: '',
    subjectServiceType: 'Permanent',
    workConnectionName: '',
    declarationDate: '2024-06-14',
    expiryDate: '2025-06-14',
  },
  concessionCard: {
    hasConcessionCard: true,
    cardList: [
      {
        id: '1235',
        cardType: 'PCC', // is active
        cardNumber: '100000000A',
        expiryDate: '2022-12-01',
        startDate: '2021-01-01',
      },
      {
        id: '1236',
        cardType: 'HCC', // is active, end in future
        cardNumber: '100000000B',
        expiryDate: '2023-12-01',
        startDate: '2022-03-01',
        endDate: '2024-01-01',
      },
      {
        id: '1237',
        cardType: 'VSPC', // no end date, start in future
        cardNumber: '100000000C',
        expiryDate: '2025-01-01',
        startDate: '2024-12-01',
      },
      {
        id: '1239',
        cardType: 'HCC', // not active
        cardNumber: '100000000D',
        expiryDate: '2024-01-01',
        startDate: '2022-01-01',
        endDate: '2022-01-02',
      },
      // {
      //   id: '1240',
      //   cardType: 'CSHC', // is active, expired
      //   cardNumber: '100000000E',
      //   expiryDate: '2022-01-01',
      //   startDate: '2021-01-01',
      // },
    ],
    lastModified: '',
  },
  studentDeclaration: {
    instituteName: 'DHL University',
    startDate: '2022-03-01',
    endDate: '2025-02-28',
  },
  membershipSummary: {
    extrasOnly: false,
  },
  registrationStatus: true,
  mfaRegistrationStatus: true,
  mfaEnforcementStatus: "Yes",
  globalMfaStatus: true,
};
